import { useEffect } from 'react';
import * as dd from 'dingtalk-jsapi';
import { connect } from 'react-redux';

function DdLogin() {
	//截取url中的参数
	function getUrlValue(kValue) {
		var url = window.location.href; //当前页面的地址
		var reg = /([^?&=]+)=([^?&=]+)/g;
		var obj = {};
		url.replace(reg, function () {
			obj[arguments[1]] = arguments[2];
		});
		for (var keyName in obj) {
			if (keyName === kValue) {
				return obj[keyName];
			}
		}
	}
	useEffect(() => {
		// 拿到路径判断是否是钉钉OA跳转过来的参数
		if (dd.env.platform !== 'notInDingTalk') {
			dd.ready(() => {
				dd.runtime.permission.requestAuthCode({
					corpId: getUrlValue('corpId'),
					onSuccess: function (result) {
						const ddCode = result.code;
						dd.biz.util.openLink({
							url: `${process.env.REACT_APP_SSO_URL}/fcDdLogin?code=${ddCode}&corpId=${getUrlValue('corpId')}`,
							onSuccess: function (result) {
								console.log(result, 'result');
							},
							onFail: function (err) {}
						});
					},
					onFail: function (err) {
						console.log(err);
					}
				});
			});
		}
	}, []); // eslint-disable-line react-hooks/exhaustive-deps
	return <div className="ddLogin"></div>;
}

const mapStateToProps = (state) => {
	return {};
};
const mapDispatchToProps = (dispatch) => {
	return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(DdLogin);
